import { UpcomingEvent } from '../types/types';
const { DateTime } = require('luxon');
const DATE_FORMAT = 'YYYY-MM-DD HH:mm';

// Date format 'YYYY-MM-DD HH:mm'

const UPCOMING_EVENTS: UpcomingEvent[] = [
  {
    name: 'HALU',
    date: DateTime.fromFormat('2026-09-12 13:00', 'yyyy-MM-dd HH:mm', {
      zone: 'America/Los_Angeles',
    }).toString(),
    rsvp: '/halu/register',
    location: 'KJRI, 1630 Alberni Street',
    locationLink:
      'https://www.google.com/maps/search/?api=1&query=KJRI+1630+Alberni+Street+Vancouver+BC+V6G+1A6',
    type: 0,
  },
];

const UPCOMING_EVENTS_DEFAULT: UpcomingEvent = {
  name: 'No Upcoming Events',
  date: '0000-00-00 00:00',
  rsvp: '',
  location: '',
  locationLink: '',
  type: 0,
};

const HIRING_DESCRIPTION = "";
const HIRING_BUTTON = 'Join PERMIKA';

const EVENT_DESCRIPTION = "";
const EVENT_BUTTON = 'Register Now';

export {
  DATE_FORMAT,
  UPCOMING_EVENTS,
  UPCOMING_EVENTS_DEFAULT,
  EVENT_DESCRIPTION,
  EVENT_BUTTON,
  HIRING_DESCRIPTION,
  HIRING_BUTTON,
};
